import { observable, action, runInAction } from "mobx";
import { FieldType, ViewModelBase } from "@shoothill/core";
import { DailyProgrammeProgressUpdateV2ItemModel } from "./DailyProgrammeProgressUpdateV2ItemModel";

export class DailyProgrammeProgressUpdateV2ItemViewModel extends ViewModelBase<DailyProgrammeProgressUpdateV2ItemModel> {
    @observable model: DailyProgrammeProgressUpdateV2ItemModel;
    constructor(model: DailyProgrammeProgressUpdateV2ItemModel) {
        super(model, false);
        this.model = model;
        this.setDecorators(DailyProgrammeProgressUpdateV2ItemModel);
    }
    // @action
    // public setPercentageCompletion(value: string) {
    //     const percentage = parseInt(value, 10);
    //     if (!isNaN(percentage) && percentage >= 0 && percentage <= 100) {
    //         this.model.percentageCompletion = percentage;
    //     }
    // }
    @action
    public reset() {
        runInAction(() => {
            this.model.activity = "";
            this.model.trade = "";
            this.model.percentageCompletion = "";
        });
    }
    public async isFieldValid(fieldName: keyof FieldType<DailyProgrammeProgressUpdateV2ItemModel>): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);
        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
